"use strict";

module.exports = function () {
	if (typeof globalThis !== "object") return false;
	if (!globalThis) return false;
	return globalThis.Array === Array;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ext/global-this/is-implemented.js
// module id = u1P+
// module chunks = 0